import CityPageTemplate from "../city-template/CityPageTemplate";
import { sanMateoConfig } from "./data";

export default function SanMateoPage() {
  return <CityPageTemplate config={sanMateoConfig} />;
}